// extracted by mini-css-extract-plugin
export default {"emblaViewport":"OHCVsSEibYNvprSs3HsKyw==","emblaContainer":"wJVRtIgaQiPOdcHTsokAMQ==","emblaSlide":"i0dGFYw-CdmYtLJKwRFHVg=="};